
import { Observable } from 'rxjs';
import * as actions from '../actions.js';
import hash from '../reducers/hasher.js';

export function autoMiner(action$, store) {
    let currentMiningState,
        currentDelay = 300;
    return action$.ofType('MINING-SET-NONCE', 'MINING-AUTO-TOGGLE')
        .filter(function autoOn() {
            const { mining } = store.getState();
            currentMiningState = mining;
            return mining.autoMining;
        })
        .flatMap(function tryNewValue() {
            if( currentDelay > 5 ) {
                currentDelay -= 15;
                currentDelay = Math.max(currentDelay, 5);
            }
            const action = actions.miningSetNonce(currentMiningState.nonce + 1);
            return Observable.of(action).delay(currentDelay);
        })
};

export function backgroundMiner(action$, store) {
    return action$.ofType('MINING-BACKGROUND-START')
        .debounceTime(500)
        .flatMap(function findValue() {
            console.log('beginning background mining...');
            const { mining } = store.getState();
            for( let i = 0, nonce = mining.nonce; i < 100000000; i++, nonce++ ) {
                const result = hash(mining.sampleData + nonce);
                let success = true;
                for( let j = 0; j < mining.difficulty; j++ ) {
                    if( result[j] !== '0' ) {
                        success = false;
                        break;
                    }
                }
                if( success ) {
                    console.log('SUCCESS', nonce);
                    return Observable.of(actions.miningBackgroundDone(nonce));
                }
            }
            console.log('finished background mining.');
            return Promise.resolve({type:'NO-OP'});
        })
};





// WEBPACK FOOTER //
// ./src/epics/block-mining-epics.js